import { render, staticRenderFns } from "./CartAddButton.vue?vue&type=template&id=37f531c0&scoped=true&"
import script from "./CartAddButton.vue?vue&type=script&lang=js&"
export * from "./CartAddButton.vue?vue&type=script&lang=js&"
import style0 from "./CartAddButton.vue?vue&type=style&index=0&id=37f531c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f531c0",
  null
  
)

export default component.exports